<template>
    <el-dialog
        :title="modalTitle"
        :visible="visible"
        custom-class="fixed-size-modal"
        @open="handleOpen"
        @close="$emit('close')"
    >
        <el-form
            v-if="visible"
            class="supplier-modal-form"
            label-position="top"
        >
            <el-tabs
                ref="tabs"
                v-model="activeTab"
                class="supplier-modal-form__tabs"
            >
                <el-tab-pane
                    label="Supplier Details"
                    name="supplier_details"
                    class="tab-content"
                >
                    <supplier-details-form
                        ref="supplier-details-form"
                        :current-supplier="currentSupplier"
                    ></supplier-details-form>
                </el-tab-pane>
                <el-tab-pane
                    label="Products"
                    name="products"
                    class="tab-content"
                >
                    <products-manager
                        :supplier-id="
                            isEditingExistingSupplier ? currentSupplier._id : ''
                        "
                        :height="480"
                    ></products-manager>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <div slot="footer">
            <el-button
                v-if="isEditingExistingSupplier"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete"
                >Delete Supplier</el-button
            >
            <el-button
                icon="el-icon-delete"
                type="danger"
                @click="handleDeleteProducts"
                >Delete All Products</el-button
            >
            <el-button type="primary" icon="el-icon-save" @click="handleSave"
                >Save</el-button
            >
        </div>
    </el-dialog>
</template>

<script>
import ProductsManager from "Components/ProductsManager.vue";

import SupplierDetailsForm from "./SupplierDetailsForm.vue";
import SupplierProductsTab from "./SupplierProductsTab.vue";

export default {
    components: {
        ProductsManager,
        SupplierDetailsForm,
        SupplierProductsTab,
    },
    props: {
        initialActiveTab: String,
        visible: Boolean,
        currentSupplier: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data: () => ({
        activeTab: "supplier_details",
        tabContentHeight: 0,
    }),
    computed: {
        modalTitle() {
            if (this.currentSupplier._id) {
                return `Edit Suppler | ${this.currentSupplier.name}`;
            }

            return "Create New Global Supplier";
        },
        isEditingExistingSupplier() {
            return !!this.currentSupplier._id;
        },
    },
    methods: {
        handleOpen() {
            if (this.initialActiveTab) {
                this.activeTab = this.initialActiveTab;
            }
        },

        handleSave() {
            const supplier = this.$refs["supplier-details-form"]
                .supplierDetails;
            this.$emit("save", supplier);
        },
        handleDelete() {
            if (this.currentSupplier._id) {
                this.$confirm(
                    `Are you sure you wish to delete the supplier ${
                        this.currentSupplier.name
                    }?`,
                    "Confirm Delete",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit("delete", this.currentSupplier._id);
                    })
                    .catch(() => {});
            }
        },
        handleDeleteProducts() {
            if (this.currentSupplier._id) {
                this.$confirm(
                    `Are you sure you wish to delete ALL products for "${
                        this.currentSupplier.name
                    }"?`,
                    "Confirm Delete",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit(
                            "delete:supplier-products",
                            this.currentSupplier._id
                        );
                    })
                    .catch(() => {});
            }
        },
    },
};
</script>

<style scoped lang="scss">
.supplier-modal-form {
    height: 100%;

    .supplier-modal-form__tabs {
        height: 100%;
        display: flex;
        flex-direction: column;

        /deep/ .el-tabs__content {
            flex: 1;
        }

        .tab-content {
            height: 100%;
        }
    }
}
</style>
